import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup} from '@angular/forms';
import { DatePipe} from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Router } from '@angular/router';
import * as moment from 'moment';
import 'rxjs/add/observable/of';
import { FiltrosDeudas } from 'app/models/FiltrosDeudas';
import { DeudasService } from 'app/services/cobranzas/deudas/deudas.service';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
    selector: 'app-listado-deudas',
    templateUrl: './listado-deudas.component.html',
    styleUrls: ['./listado-deudas.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,DatePipe,
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
          },
      
          { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class ListadoDeudasComponent{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  DTOFiltrosDeudas: FiltrosDeudas = new FiltrosDeudas();
  today = moment();
  loading:boolean;
  TipoMoneda : any = [];
  data : any =  [];
  deuda : any = [];
  deudas: any = [];
  arrayProductos : any;
  productos : boolean = false;
  //flagDeudasDetalle: boolean = false;
  abrirRegistroDeudas : boolean = false;
  abrirFacturacionDeuda : boolean = false;
  abrirPagarDeuda : boolean = false;
  user:any;

  id;
  idCli ="" ;
  RUC_CLI : string;
  cliId = new FormControl();
  filteredCliente: Observable<any[]>;
  clientesArr;
  ruc = new FormControl();
  arrayDeuda = [];

  filteredProveeedor: Observable<any[]>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked','idDeuda','Razon_Social','Alta_Fecha','Moneda','Deuda_Importe','Saldo_Importe','Descripcion','Estado']
  
  dataSource: any;
    
  constructor(private loginService:LoginService,
    private datePipe:DatePipe,
                private router:Router,
                private DeudasService1:DeudasService,
                private datepipe :DatePipe){ 
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
   this.ObtenerClienteCombo();
    this.DTOFiltrosDeudas.FechaIni = this.datepipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosDeudas.FechaFin = this.datepipe.transform(moment(),'yyyy-MM-dd');
  }

  ngOnInit(){
 
    this.ListadoDeudasFiltros();
    this.obtenerProductos();        
  }

  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosDeudas.Moneda = 0;
    }else{
      this.DTOFiltrosDeudas.Moneda = event;
    } 
  }
   
  EnterobtenerRucRazSocialCli(termino :string = ''){
    let RUCempresa = '';
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.clientesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
          }
      }
      this.DTOFiltrosDeudas.idEmpresa = this.id;
    }
  }

  obtenerId(provId :string){
    this.DTOFiltrosDeudas.idEmpresa = provId;
  }

  ObtenerClienteCombo() {
    this.clientesArr = JSON.parse(sessionStorage.getItem('lstCliCbo'));

      this.filteredCliente = this.cliId.valueChanges.pipe(
        startWith(""),
        map(state => state ? this._filterCli(state) : this.clientesArr.slice()
        )
      );
  }

  private _filterCli(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.clientesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }
     
  ListadoDeudasFiltros(){

    this.loading = true;

    this.DTOFiltrosDeudas.FechaIni = this.datepipe.transform(this.DTOFiltrosDeudas.FechaIni,'yyyy-MM-dd')
    this.DTOFiltrosDeudas.FechaFin = this.datepipe.transform(this.DTOFiltrosDeudas.FechaFin,'yyyy-MM-dd')
    this.DeudasService1.filtroListadoDeudas(this.DTOFiltrosDeudas).subscribe(
      res =>{
          this.deudas = res;
          this.dataSource = new MatTableDataSource( this.deudas);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    )
  }
  obtenerProductos(){
    this.DeudasService1.obtenerProductos().subscribe(res =>{
      this.arrayProductos = res;
    })
  }

  editarDeuda(element){
    element.productos = this.arrayProductos;
    this.deuda = element;
    this.abrirRegistroDeudas = true;
  }

  CerrarPopUpRegDeudas(){
    this.ListadoDeudasFiltros();
    this.abrirRegistroDeudas = false;
  }

  
  facturarDeuda(element){
    element.productos = this.arrayProductos;
    this.deuda = element;
    this.abrirFacturacionDeuda = true;
  }

  CerrarPopUpFacDeuda(){
    this.ListadoDeudasFiltros();
    this.abrirFacturacionDeuda = false;
  }
  
  pagarDeuda(element){
    this.arrayDeuda.push(element);
    this.abrirPagarDeuda = true;
  }

  CerrarPopUpPagoDeuda(){
    this.arrayDeuda = [];
    this.ListadoDeudasFiltros();
    this.abrirPagarDeuda = false;
  }

  darBajaDeuda(element){

    let frmBajaDeuda = new FormGroup({
      'idDeuda' : new FormControl(element.idDeuda),
      'canal' : new FormControl("W"),
      'user' : new FormControl(this.user.Usuario)
    })

    Swal.fire({
      title:'Anular Deuda',
      html:'<span>¿Desea anular la deuda Nro <b>'+element.idDeuda+'</b> del '+this.Label_Proveedor.toLowerCase()+' <b>'+element.Razon_Social+'</b>?</span>',
      type: 'warning',
      focusConfirm: false,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor:'#FC3333',
      cancelButtonColor:'#3351FC',
      confirmButtonText:'Si,confirmar.',
      cancelButtonText: 'No, cancelar',
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        
        this.DeudasService1.bajaDeuda(frmBajaDeuda.getRawValue()).subscribe(
          res =>{ 
            Swal.fire({
              title: '¡Deuda anulada!',
              text: 'La planilla Nro '+element.idDeuda+' ha sido anulada.',
              type: 'success',
              heightAuto: false
            }).then(resp =>{
              if(resp.value == true){
                Swal.close();
                this.ListadoDeudasFiltros();
              }
            });
          },
          err =>{
            Swal.fire({
              title: "Error",
              text: 'No se pudo anular la deuda Nro '+element.idDeuda+'.',
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        )
        }
    });
  }
}